import React from 'react';
import AdminFullNameRequiredModal from '../../components/admin/settings/AdminFullNameRequiredModal.js';
import AdminQuickTaskGlobalLauncher from '../../components/admin/tasks/AdminQuickTaskGlobalLauncher.jsx';
import AdminWorkAvailabilityPrompt from '../../components/common/workAvailability/AdminWorkAvailabilityPrompt';
import ArtistDemoBanner from '../../components/common/manuals/ArtistDemoBanner';
import ConnectivityBanner from '../../components/common/ConnectivityBanner';
import GlobalSocketListener from '../../components/common/GlobalSocketListener';
import Header from '../../components/common/header/Header.js';
import MaintenanceBanner from '../../components/common/maintenance/MaintenanceBanner';
import PeerToastStack from '../../components/common/PeerToastStack';
import { AdminMenuBadgeProvider } from '../../contexts/AdminMenuBadgeContext';
import { ContractCountProvider } from '../../contexts/ContractCountContext';
import { MessageCountProvider } from '../../contexts/MessageCountContext';
import { OfferCountProvider } from '../../contexts/OfferCountContext';
import { PdfPreviewProvider } from '../../components/common/pdf/PdfPreviewProvider';
import { ResponseStatusProvider } from '../../components/common/workAvailability/ResponseStatusProvider';

export default function AppShellLayout({ children, isLocalUiMock, closeSidebarOverlay }: { children: React.ReactNode; isLocalUiMock: boolean; closeSidebarOverlay: () => void }) {
  return (
    <>
      <OfferCountProvider>
      <ContractCountProvider>
      <AdminMenuBadgeProvider>
      <MessageCountProvider>
        <ResponseStatusProvider>
        <PdfPreviewProvider>
          {!isLocalUiMock ? <GlobalSocketListener /> : null}
          {!isLocalUiMock ? <ArtistDemoBanner /> : null}
          {!isLocalUiMock ? <Header /> : null}
          {!isLocalUiMock ? <AdminFullNameRequiredModal /> : null}
          {!isLocalUiMock ? <AdminWorkAvailabilityPrompt /> : null}
          {!isLocalUiMock ? <MaintenanceBanner /> : null}
          {!isLocalUiMock ? <ConnectivityBanner /> : null}
          <main id="app-shell" role="main" aria-label="Application Content">
            <div
              className="sidebar-mobile-overlay"
              aria-hidden="true"
              onClick={closeSidebarOverlay}
            />
            <div className="app-shell__viewport">
              {children}
              {!isLocalUiMock ? <AdminQuickTaskGlobalLauncher /> : null}
            </div>
          </main>
          {!isLocalUiMock ? <PeerToastStack /> : null}
        </PdfPreviewProvider>
        </ResponseStatusProvider>
      </MessageCountProvider>
      </AdminMenuBadgeProvider>
      </ContractCountProvider>
      </OfferCountProvider>
    </>
  );
}
